export default __webpack_public_path__ + "static/media/skills-dark.71d8fb4d.svg";